import { render, staticRenderFns } from "./IndexAlert.vue?vue&type=template&id=737435ad&"
import script from "./IndexAlert.vue?vue&type=script&lang=js&"
export * from "./IndexAlert.vue?vue&type=script&lang=js&"
import style0 from "./IndexAlert.vue?vue&type=style&index=0&id=737435ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports